module.exports = __webpack_public_path__ + "static/img/PANInfoModal.7ffd4d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/PANInfoModal.png
// module id = S9o/
// module chunks = 3